
class ProductSwatches extends HTMLElement {
  constructor() {
    super();

    this.swatchTitle = this.parentNode.querySelector(".js-selected-swatch");
    this.swatches = this.querySelectorAll(".colour-swatch");
    this.inputs = this.querySelectorAll("input[type='radio']");

    if (this.swatchTitle) {
      this.swatches.forEach((swatch) => {
        swatch.addEventListener("mouseover", () => {
          const colourTitle = swatch.getAttribute("data-name");

          if (colourTitle) {
            this.swatchTitle.textContent = colourTitle;
          }
        });

        swatch.addEventListener("mouseleave", () => {
          this.updateSwatchTitle();
        });
      });

      this.inputs.forEach((input) => {
        input.addEventListener("change", () => {
          this.updateSwatchTitle();
        });
      });
    }
  }

  connectedCallback() {
    this.onVariantChange = this.handleVariantChange.bind(this);

    document.addEventListener(
      "variant:change",
      this.onVariantChange
    );
  }

  disconnectedCallback() {
    document.removeEventListener(
      "variant:change",
      this.onVariantChange
    );
  }

  updateSwatchTitle() {
    const selectedInput = Array.from(this.inputs).find(
      (input) => input.checked
    );

    if (selectedInput && this.swatchTitle) {
      this.swatchTitle.textContent = selectedInput.value;
    }
  }

  handleVariantChange(event) {
    const detail = event.detail || {};
    const variant = detail.variant || detail;

    if (!variant || variant.price == null) return;

    const section = this.closest(".js-product-top");

    if (!section) return;

    // Prevent multiple swatch groups updating the same prices.
    if (
      section.querySelector("product-swatches") !== this
    ) {
      return;
    }

    const currency =
      window.Shopify?.currency?.active || "GBP";

    const locale =
      currency === "EUR"
        ? "fr-FR"
        : `${window.Shopify?.locale || "en"}-${window.Shopify?.country || "GB"}`;

    const price = Number(variant.price) / 100;

    const compareAtPrice =
      variant.compare_at_price != null
        ? Number(variant.compare_at_price) / 100
        : null;

    if (!Number.isFinite(price)) return;

    const hasDiscount =
      compareAtPrice !== null &&
      Number.isFinite(compareAtPrice) &&
      compareAtPrice > price;

    const percentageDiscount = hasDiscount
      ? Math.round(
          ((compareAtPrice - price) / compareAtPrice) * 100
        )
      : 0;

    const formattedPrice = this.formatPrice(
      price,
      locale,
      currency
    );

    const formattedCompareAtPrice = hasDiscount
      ? this.formatPrice(compareAtPrice, locale, currency)
      : "";

    // Update desktop, mobile and sticky price containers.
    const priceContainers = section.querySelectorAll(
      ".js-product-price"
    );

    priceContainers.forEach((container) => {
      const regularPrice = container.querySelector(
        ".price-item--regular"
      );

      const salePrice = container.querySelector(
        ".price-item--sale"
      );

      const comparePrice = container.querySelector(
        ".price-item--compare"
      );

      const percentageContainer = container.querySelector(
        ".price__percentage"
      );

   // Update the visible price.
const visiblePrice =
  container.querySelector(
    ".price__sale .price-item--sale"
  ) ||
  container.querySelector(
    ".price__regular .price-item--regular"
  ) ||
  container.querySelector(
    ".price-item:not(.price-item--compare)"
  );

if (visiblePrice) {
  visiblePrice.textContent = formattedPrice;
}

      // Update compare-at price.
      if (comparePrice) {
        comparePrice.textContent = hasDiscount
          ? formattedCompareAtPrice
          : "";
      }

      // Update percentage discount.
      if (percentageContainer) {
        percentageContainer.textContent = hasDiscount
          ? `(-${percentageDiscount}%)`
          : "";
      }

      // Update sale styling where supported.
      const priceWrapper = container.querySelector(".price");

      if (priceWrapper) {
        priceWrapper.classList.toggle(
          "price--on-sale",
          hasDiscount
        );
      }
    });
  }

  formatPrice(price, locale, currency) {
    let formatted = new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      currencyDisplay: "symbol",
      minimumFractionDigits: price % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(price);

    if (currency === "EUR") {
      formatted = this.cleanFormattedPrice(formatted);
    }

    if (currency === "MYR") {
      formatted =
        formatted.replace(/\s/g, "") + " " + currency;
    }

    return formatted;
  }

  cleanFormattedPrice(formattedPrice) {
    const formattedPriceStr =
      formattedPrice.slice(-1) +
      formattedPrice.slice(0, -1);

    return formattedPriceStr.replace(/\u00A0/g, " ");
  }
}

if (!customElements.get("product-swatches")) {
  customElements.define("product-swatches", ProductSwatches);
}
